module.exports = __webpack_public_path__ + "static/media/logo.89bf2510.webp";